import React from "react";
import AppDownloadPromo from "web/react/components/app-download-promo/app-download-promo";
import { AppFooter } from "web/react/components/app-footer/app-footer";
import { CustomerCaptureOverlay } from "web/react/components/customer-capture-overlay/customer-capture-overlay";
import { FooterProps } from "web/react/components/footer/footer";
import withReduxProvider from "web/react/redux-provider";
import { RawBranchLink } from "web/script/utils/branch-io";
import styles from "./4xx.module.css";

interface FourXXProps {
    mainHeading: string;
    subtitle: string;
    helpCentreLinkTextHTML: string;
    footer: FooterProps;
}

function FourXX({
    mainHeading,
    subtitle,
    helpCentreLinkTextHTML,
    footer,
}: FourXXProps): JSX.Element {
    return (
        <>
            <div className={styles.httpErrorLayout}>
                <div className={styles.preHeader}>
                    <h1>
                        <span className={styles.heading}>{mainHeading}</span>
                    </h1>
                </div>
                <div className={styles.errorContent}>
                    <p>{subtitle}</p>
                    <p dangerouslySetInnerHTML={{ __html: helpCentreLinkTextHTML }} />
                </div>
            </div>
            <CustomerCaptureOverlay />
            <AppDownloadPromo branchLink={RawBranchLink.PageNotFound} />
            <AppFooter {...footer} />
        </>
    );
}

export default withReduxProvider(FourXX);
